module.exports = __webpack_public_path__ + "img/pfondo3.c0752c1b.png";